<div class="message-thread-container" [ngClass]="{ mobile: isMobileLayout }">
  <!-- CONTAINS ALL MESSAGES FROM THREAD -->
  <div class="messages custom-scroll">
    <ng-container *ngFor="let message of messages">
      <app-message-container
        [message]="message"
        [currentUser]="message.senderDetails?.name === user.partnerKey"
        [user]="user"
      ></app-message-container>
    </ng-container>
  </div>

  <div class="message-input border-top">
    <button
      class="btn btn-danger"
      (click)="chatInputModel.openModal(isMobileLayout)"
    >
      {{ prefix + "send-msg" | msg | async }}
    </button>
  </div>
</div>

<app-user-message-chat-input-modal
  #chatInputModel
  (submitEvent)="submit($event!)"
></app-user-message-chat-input-modal>
